import startWidget from './startWidget';
import overview from './overview';
import checkout from './checkout';
import productComparison from './productComparison';

export { startWidget, overview, productComparison, checkout };

export const layout = [startWidget, overview, productComparison, checkout];
